<template>
    <v-snackbar
         v-model="show"
         :bottom="y === 'bottom'"
         :left="x === 'left'"
         :multi-line="mode === 'multi-line'"
         :right="x === 'right'"
         :timeout="timeout"
         :top="y === 'top'"
         :vertical="mode === 'vertical'"
         :color="color"
                
       >
       <v-layout class="px-2 py-2" align-center row>
          <v-flex pr-3 v-if="icon">
            <i :class="`fas fa-${icon} fa-2x`"></i>
          </v-flex>
          <v-flex>
            {{text}}
          </v-flex>         
        </v-layout>         
     </v-snackbar>
</template>

<script>
import * as types from "../../store/types"
import { colors } from "../../config"
import { mapGetters } from 'vuex'
export default {
    data () {
      return {
          y: 'bottom',
          x: null,
          mode: 'multi-line',
          show: false
      }
   },
   watch:{
     notificationData(nv){
         this.show = nv ? true : false;
     }
   },
   computed:{
     ...mapGetters({
       notificationData: types.SHOW_NOTIFICATION
     }),
     text(){
       return this.notificationData ? this.notificationData.text : "";
     },
     timeout(){
       return this.notificationData ? this.notificationData.options.timeout : 0;
     },
     color() {
       let color = null;
       if(this.notificationData && this.notificationData.options){
        if(this.notificationData.options.color){
          color = this.notificationData.options.color
        }
        if(this.notificationData.options.type){
          switch(this.notificationData.options.type) {
            case 'info' :
              color = colors.info
              break;
            case 'error' :
              color = colors.error
              break;
            case 'warning' :
              color = colors.warning
              break;
            case 'success' :
              color = colors.success
              break;
          }
        }
       }
       return color;
     },
     icon(){
       return this.notificationData ? this.notificationData.options.icon : null;
     }
   }
}
</script>

<style scoped>
  .snackbar-icon-container{
    background-color: rgba(255,255,255,0.2);
    height: 40px;
    width: 40px;
    border-radius: 50%;
    justify-content: center;
    text-align: center;
    align-items:center;
    font-size: 10px;
    display:flex;
  }
</style>
